/**
 * @file 自定义服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {omit} from 'lodash';

export default class CustomServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'custom';

    formData = {
        appId: '',
        name: '',
        description: ''
    };

    adaptData(data) {
        if (this.pageType === 'detail') {
            this.setAppDatasourceFromDetail(data);
        }
        return super.adaptData(data);
    }

    prepareData(data) {
        if (this.pageType === 'edit') {
            data = omit(data, ['appId']);
        }
        return super.prepareData(data);
    }
}
